export default __webpack_public_path__ + "static/media/pic_four.5a6c9a38.jpeg";